import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { makeStyles, Typography, ShadowContainer, Dialog, DialogActions, RaiseColors, DialogContent, Icon, IconConstants, IconButton, useTheme, useMediaQuery, ButtonVariantEnum } from "componentLibrary";
import RaiseButton from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
      padding: "0px"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline"
    },
    body: {
      display: "flex",
      flexDirection: "column"
    },
    footer: {
      display: "flex",
      alignItems: "center",
      padding: "0px",
      gap: "12px 4px",
      // vert & horiz gaps (vert gap is used when screen is so small that buttons wrap)
      flexWrap: "wrap"
    },
    dialogPaperProps: {
      borderRadius: "16px",
      width: "512px",
      maxWidth: "calc(100vw - 32px)",
      padding: "24px",
      gap: "32px"
    }
  };
});
var CustomDialog = function CustomDialog(_ref) {
  var open = _ref.open,
    title = _ref.title,
    _onClose = _ref.onClose,
    _ref$disableCloseOnBa = _ref.disableCloseOnBackdropClick,
    disableCloseOnBackdropClick = _ref$disableCloseOnBa === void 0 ? false : _ref$disableCloseOnBa,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
    _ref$hideCancelButton = _ref.hideCancelButton,
    hideCancelButton = _ref$hideCancelButton === void 0 ? false : _ref$hideCancelButton,
    _ref$cancelText = _ref.cancelText,
    cancelText = _ref$cancelText === void 0 ? "Cancel" : _ref$cancelText,
    _ref$primaryButtonTex = _ref.primaryButtonText,
    primaryButtonText = _ref$primaryButtonTex === void 0 ? "Confirm" : _ref$primaryButtonTex,
    onPrimaryAction = _ref.onPrimaryAction,
    _ref$primaryButtonDis = _ref.primaryButtonDisabled,
    primaryButtonDisabled = _ref$primaryButtonDis === void 0 ? false : _ref$primaryButtonDis,
    customFooter = _ref.customFooter,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "512px" : _ref$width,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "calc(100vw - 32px)" : _ref$maxWidth,
    padding = _ref.padding,
    contentGap = _ref.contentGap,
    footerGap = _ref.footerGap,
    _ref$resetContentTopP = _ref.resetContentTopPadding,
    resetContentTopPadding = _ref$resetContentTopP === void 0 ? false : _ref$resetContentTopP,
    children = _ref.children,
    headerContent = _ref.headerContent,
    bodyContent = _ref.bodyContent,
    testId = _ref["data-testid"];
  var classes = useStyles();
  var theme = useTheme();
  var mdDown = useMediaQuery(theme.breakpoints.down("md"));
  var buttonSize = mdDown ? "small" : "medium";
  var paperProps = {
    className: classes.dialogPaperProps,
    style: _objectSpread(_objectSpread({
      width: width,
      maxWidth: maxWidth
    }, padding ? {
      padding: padding
    } : {}), footerGap ? {
      gap: footerGap
    } : {})
  };
  var renderHeader = function renderHeader() {
    if (!title && !headerContent && !showCloseButton) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: classes.header,
      children: [headerContent || /*#__PURE__*/_jsx(Typography, {
        weight: "semibold",
        variant: "h4",
        color: RaiseColors.glacier2400,
        children: title
      }), showCloseButton && /*#__PURE__*/_jsx(IconButton, {
        onClick: _onClose,
        children: /*#__PURE__*/_jsx(Icon, {
          fontSize: 16,
          className: IconConstants.X,
          color: RaiseColors.glacier2400
        })
      })]
    });
  };
  var renderBody = function renderBody() {
    if (!bodyContent && !children) return null;
    return /*#__PURE__*/_jsxs("div", {
      className: classes.body,
      children: [bodyContent, children]
    });
  };
  var renderFooter = function renderFooter() {
    if (customFooter) {
      return /*#__PURE__*/_jsx(DialogActions, {
        className: classes.footer,
        children: customFooter
      });
    }
    var showCancel = !hideCancelButton;
    return /*#__PURE__*/_jsxs(DialogActions, {
      className: classes.footer,
      children: [showCancel && /*#__PURE__*/_jsx(RaiseButton, {
        variant: ButtonVariantEnum.secondary,
        size: buttonSize,
        onClick: _onClose,
        children: cancelText
      }), /*#__PURE__*/_jsx(RaiseButton, {
        variant: ButtonVariantEnum.primary,
        size: buttonSize,
        onClick: onPrimaryAction,
        disabled: primaryButtonDisabled,
        children: primaryButtonText
      })]
    });
  };
  return /*#__PURE__*/_jsx(ShadowContainer, {
    "data-testid": testId,
    children: /*#__PURE__*/_jsxs(Dialog, {
      onClose: function onClose(event, reason) {
        if (disableCloseOnBackdropClick) {
          if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
            _onClose();
          }
        } else {
          _onClose();
        }
      },
      open: open,
      PaperProps: paperProps,
      children: [/*#__PURE__*/_jsxs(DialogContent, {
        className: classes.content,
        style: _objectSpread(_objectSpread({}, contentGap ? {
          gap: contentGap
        } : {}), resetContentTopPadding ? {
          paddingTop: 0
        } : {}),
        children: [renderHeader(), renderBody()]
      }), renderFooter()]
    })
  });
};
export default CustomDialog;